/**
 * iter551 · <FlytWings /> — the brand's white wings mark rendered as a
 * lucide-style inline icon so it can slot into any place we were using
 * `<Sparkles />` next to the "FLYT ID™" wordmark.
 *
 * Sources the same `white-wings_edited.png` asset that ChannelWordmark
 * already trusts. Uses object-contain so aspect ratio survives at any
 * size and `aria-hidden` because the adjacent text label already tells
 * screen readers what this is.
 */
const WING_IMG = 'https://customer-assets.emergentagent.com/job_jay-pernell-sports/artifacts/z7u9j3pl_white%20wings_edited.png';

export const FlytWings = ({ className = 'w-3 h-3', style }) => (
  <img
    src={WING_IMG}
    alt=""
    aria-hidden="true"
    draggable="false"
    className={`${className} object-contain select-none`}
    // iter656 · Force pure white regardless of the source PNG's colour
    // profile. `brightness(0) invert(1)` collapses every non-alpha
    // pixel to white while preserving the wings' transparent silhouette.
    style={{ filter: 'brightness(0) invert(1)', ...(style || {}) }}
  />
);

export default FlytWings;
